import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { RedirectURLs } from '../constants/redirectURLS';

export default function Redirect() {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    switch (pathname) {
      case '/twitter': {
        window.location.href = RedirectURLs.twitter;
        break;
      }
      case '/linkedin': {
        window.location.href = RedirectURLs.linkedin;
        break;
      }
      case '/discord': {
        window.location.href = RedirectURLs.discord;
        break;
      }
      case '/reddit': {
        window.location.href = RedirectURLs.reddit;
        break;
      }
      case '/medium': {
        window.location.href = RedirectURLs.medium;
        break;
      }
      case '/youtube': {
        window.location.href = RedirectURLs.youtube;
        break;
      }
      default: {
        break;
      }
    }
  }, [navigate, pathname]);

  return null;
}
